<template>
  <div class="c-popup-share-tip" v-show="shareWechat">
    <div class="share-msg">
      <div class="share-close" @click="handleClose"></div>
    </div>
  </div>
</template>
<script>
import { SET_SHARE_WECHAT } from '../store/mutationTypes';

export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    shareWechat() {
      const { shareWechat } = this.$store.state;
      return shareWechat;
    },
  },
  methods: {
    handleClose() {
      this.$store.commit(SET_SHARE_WECHAT, false);
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
};
</script>
<style lang="scss">
.c-popup-share-tip {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);

  .share-msg {
    position: absolute;
    top: -6%;
    right: 0;
    width: 60%;
    padding-top: 68%;
    background: url('../assets/images/download/tips@2x.png') center center no-repeat;
    background-size: contain;
  }

  .share-close {
    position: absolute;
    width: 6%;
    height: 6%;
    top: 52%;
    right: 20%;
    background: url('../assets/images/download/close@2x.png') center center no-repeat;
    background-size: contain;
  }
}
</style>
